import {useState, useEffect} from 'react';
import DOMPurify from 'dompurify';
import { IoClose as Close } from 'react-icons/io5';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import ProjectFolderService from '@Helpers/URLHelpers/ProjectFolderService';
import ErrorHandler from '@Root/ErrorHandler';
import './EditFolderForm.scss';

export default function EditFolderForm(props) {

    const [cursor, setCursor] = useState('auto');
    const [folderName, setFolderName] = useState('');
    const projectFolderService = new ProjectFolderService();
    const errorHandler = new ErrorHandler();
    const className = 'editFolderForm';

    useEffect(()=>{
        renderData();
    },[]);

    const renderData = ()=> {
        setFolderName(props.folderName);
    }

    const handleSubmit = async(e)=> {
        e.preventDefault();
        setCursor('wait');
        try {
            let bodyObj = {
                folderId: props.folderId,
                folderName: folderName
            }
            await projectFolderService.updateProjectFolder(bodyObj);
            props.onClose();
            await props.renderData(props.navigationParentId);
        } catch(err) {
            errorHandler.handleError(err);
        }
        setFolderName('');
        setCursor('auto');
    }

    const handleFolderNameChange = (e) => {
        let sanitizedFolderName = DOMPurify.sanitize(e.target.value);
        setFolderName(sanitizedFolderName);
    }

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}>
                <div className={className + ' width-wfa'} style={{cursor: cursor}}>
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__titleBar flex-row-center-space-between'}>
                            <div className={className + '__inner__titleBar__title flex-row-center-1vw-gap'}>
                                <div className={className + '__inner__titleBar__title__t1 standard-text-semi-large'}>Rename Folder</div>
                            </div>
                            <Close className={className + '__inner__titleBar__close close-button'}
                                onClick={props.onClose}/>
                        </div>
                        <div className={className + '__inner__body'}>
                            <form onSubmit={handleSubmit} className={className + '__inner__body__add flex-column-flex-end-2vh-gap'}>
                                <TextField
                                    value={folderName}
                                    onChange={handleFolderNameChange}
                                    className={className + '__inner__body__add__input'}/>
                                <div className={className + '__inner__body__add__button'}>
                                    <BorderBlueButtonV2
                                        disabled={folderName === '' || folderName.length === 0}
                                        text='Rename'/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
        </Modal>
    )
}